import { createContext } from 'react';
import { Issue } from '../../../constants';
export const HomeContext = createContext<HomeContextProps>({
    selectedIssue: null,
    setSelectedIssue: () => { },
    setShowInstallation: () => { },
    setShowLogout: () => { },
    onClickLogOut: () => { }
});

interface HomeContextProps {
    selectedIssue: Issue | null;
    setSelectedIssue: (issue: Issue | null) => void;
    setShowInstallation: (value: boolean) => void;
    setShowLogout: (value: boolean) => void;
    onClickLogOut: () => void;
}